import { useScroller } from 'src/app/shared/hooks/useScroller';
import type { SectionRefs } from 'src/types/sections';

interface Props {
  sectionRefs: SectionRefs;
}

export const useSectionsManager = ({ sectionRefs }: Props) => {
  const scrollToSection = useScroller();

  const sectionRefsArray = Object.values(sectionRefs);

  const hasSectionsInEditMode = () =>
    sectionRefsArray.some((s) => s.current && s.current.edit);

  const hasSectionsWithSavedChanges = () =>
    sectionRefsArray.some((s) => s.current && s.current.hasChanges);

  const resetSections = () =>
    sectionRefsArray.map(({ current }) => {
      if (current) {
        current.edit = false;
        current.hasChanges = false;
        return current;
      }
    });

  const validateSections = (): boolean => {
    const invalidSections: string[] = [];
    const sectionsInEditMode = sectionRefsArray.filter(
      (s) => s.current && s.current.edit,
    );

    for (const section of sectionsInEditMode) {
      const current = section.current;

      if (current) {
        if (!current.validate()) {
          invalidSections.push(current.name);
        }
      }
    }

    if (invalidSections.length > 0) {
      scrollToSection(invalidSections[0]);
      return false;
    }

    return true;
  };

  return {
    hasSectionsInEditMode,
    hasSectionsWithSavedChanges,
    resetSections,
    validateSections,
  };
};
